import React, {
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";

import DialogoAutorizacaoTransportadorComBiometria from '../DialogoAutorizacaoTransportadorComBiometria'
import DialogoAutorizacaoTransportadorComSenha from '../DialogoAutorizacaoTransportadorComSenha'

const DialogoAutorizacao = forwardRef(
  (
    {
      handleSalvar,
      title,
      enqueueSnackbar,
      mensagemSucesso = "Item removido com sucesso!",
      openConsultorPrecos = () => {},
      usar_biometria = false,
    },
    ref,
  ) => {

    const refDialogoAutorizacaoTransportadorComBiometria = useRef(null);
    const refDialogoAutorizacaoTransportadorComSenha = useRef(null);

    useImperativeHandle(ref, () => ({
      handleOpen(codigoNew = 0, dados = null, username) {
        if(usar_biometria) {
          if(refDialogoAutorizacaoTransportadorComBiometria.current) {
            refDialogoAutorizacaoTransportadorComBiometria.current.handleOpen(codigoNew, dados, username, () => {
              if(refDialogoAutorizacaoTransportadorComSenha.current) {
                refDialogoAutorizacaoTransportadorComSenha.current.handleOpen(codigoNew, dados, username);
              }
            });
          }
        } else {
          if(refDialogoAutorizacaoTransportadorComSenha.current) {
            refDialogoAutorizacaoTransportadorComSenha.current.handleOpen(codigoNew, dados, username);
          }
        }
      },
    }));

    return (
      <>
        <DialogoAutorizacaoTransportadorComBiometria
          ref={refDialogoAutorizacaoTransportadorComBiometria}
          handleSalvar={handleSalvar}
          title={title}
          enqueueSnackbar={enqueueSnackbar}
          mensagemSucesso={mensagemSucesso}
          openConsultorPrecos={openConsultorPrecos}
        />

        <DialogoAutorizacaoTransportadorComSenha
          ref={refDialogoAutorizacaoTransportadorComSenha}
          handleSalvar={handleSalvar}
          title={title}
          enqueueSnackbar={enqueueSnackbar}
          mensagemSucesso={mensagemSucesso}
          openConsultorPrecos={openConsultorPrecos}
        />
      </>
    );
  },
);

export default DialogoAutorizacao;
